<script lang="ts" setup>
import ArticleListItem from '@consumer/modules/support/ArticleListItem.vue'
import CategoryDispute from '@consumer/modules/support/CategoryDispute.vue'
import CategoryHeader from '@consumer/modules/support/CategoryHeader.vue'
import ContactUsCard from '@consumer/modules/support/ContactUsCard.vue'
import OrderHeader from '@consumer/modules/support/OrderHeader.vue'
import type { SupportArticle, SupportCategory } from '@consumer/types/SupportArticle'
import type { PurchasedOrder } from '@consumer/types/serializers'
import type { BuyerOrRecipientGift } from './support'

defineProps<{
  currentCategory: SupportCategory
  supportArticles: SupportArticle[]
  order?: PurchasedOrder
  gift?: BuyerOrRecipientGift
}>()
</script>

<template>
  <GCard rounded shadow class="p-6 !lg:p-8">
    <OrderHeader
      v-if="order || gift"
      :order="order"
      :gift="gift"
      :currentCategory="currentCategory"
    />

    <CategoryHeader v-else :icon="currentCategory.icon" class="bg-primary-pale mb-6">
      {{ currentCategory.label }}
    </CategoryHeader>

    <div class="paragraphs">
      <CategoryDispute v-if="currentCategory.name === 'disputes'"/>

      <template v-else>
        <h2 v-if="order" class="text-lg mb-2">
          {{ gift ? 'Gift Support' : 'Order Support' }}
        </h2>
        <p>{{ currentCategory.subtext }}</p>
        <div class="pb-6">
          <GDivider/>
        </div>
        <div class="space-y-6">
          <ArticleListItem
            v-for="article, i in supportArticles"
            :key="i"
            :article="article"
            :gift="gift"
            :order="order"
          />
        </div>
      </template>
    </div>
  </GCard>

  <ContactUsCard/>
</template>
